export default __webpack_public_path__ + "static/media/artistPage.769f31af.jpg";